import { getProxyUrl } from '.'

export type GetUnidadAgrupadaResponse = {
  escena: {
    json: string
  }
}

export async function getUnidadAgrupada(
  idUnidadesAgrupadas: number,
): Promise<GetUnidadAgrupadaResponse> {
  const url = getProxyUrl(`api/Diseno/recuperarunidadaagrupada/${idUnidadesAgrupadas}`)

  const params = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': 'ES',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  const response = await fetch(url, params as RequestInit)

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw { status: response.status, data: error }
  }

  return response.json()
}
